import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, FormDecidable } from "bm-ui-kit";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

export interface CompanyStep3Fields {
	hasConnectedCompanyUnderLiquidation: boolean;
	ownerInKhr: boolean;
	ownerDenied: boolean;
	hadMoreThanHalfOwnerChange: boolean;
}

export class CompanyStep3 extends AbstractStep<CompanyStep3Fields> {
	protected renderContent(_values: CompanyStep3Fields, form: FormApi<CompanyStep3Fields>): ReactNode {
		return (
			<>
				<Card.Body>
					<FormDecidable
						name="hasConnectedCompanyUnderLiquidation"
						label="Van a céged kapcsolt vállalkozásai között felszámolás alatt álló cég?"
						required
					/>
					<FormDecidable
						name="ownerInKhr"
						label="Tulajdonosok/ügyvezetők/magánszemély készfizető kezesek szerepelnek a KHR/BAR listán?"
						required
					/>
					<FormDecidable
						name="ownerDenied"
						label="Tulajdonosi és ügyvezető körben van cégvezetéstől eltiltott személy?"
						required
					/>
					<FormDecidable
						name="hadMoreThanHalfOwnerChange"
						label="Van 50%-nál nagyobb részben tulajdonos változás az elmúlt 6 hónapban?"
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "CompanyStep3";
	}
}
